/* eslint-disable react/jsx-key */
import Image from '@base/FutureImage';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import GridContainer from '@cont/CitySpecificOfflineCentres/CommonComponents';
import Typography from 'aquilla/core/atoms/Typography';
import CheckContained from 'aquilla/icons/misc/CheckContained';

const Container = styled.div`
  grid-column: span 24;
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${Spacings.SPACING_16B};
  margin-bottom: ${Spacings.SPACING_16B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_0B};
    margin-bottom: ${Spacings.SPACING_0B};
  }
`;

const StyledHeading = styled(Typography)`
  font-size: ${Fonts.H2};
  font-weight: ${Fonts.HEAVY};
  margin-bottom: ${Spacings.SPACING_4B};
  text-align: center;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
    font-weight: ${Fonts.HEAVY};
    margin-bottom: ${Spacings.SPACING_2B};
    text-align: inherit;
    align-self: start;
  }
`;
const ColoredHeading = styled.span`
  color: var(--color-i-violet-15);
`;

const StyledSubHeading = styled(Typography)`
  display: flex;
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_12B};
  text-align: center;
  width: 50%;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
    font-weight: ${Fonts.LIGHT};
    line-height: ${Spacings.SPACING_6B};
    width: 100%;
    margin-bottom: ${Spacings.SPACING_6B};
    text-align: inherit;
  }
`;

const InfoBlocks = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const Block = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 24px;
  padding: ${Spacings.SPACING_6B};

  width: 560px;

  border: 1px solid #e9eef2;
  border-radius: 8px;

  flex: none;
  order: 0;
  flex-grow: 1;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_3B};
  }
`;

const BlockIcon = styled(Image)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${Spacings.SPACING_0B};
  margin-right: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const BlockDetailIcon = styled(Image)`
  display: flex;
  flex-wrap: wrap;
  margin-left: ${Spacings.SPACING_3B};
  ${mediaQuery.uptoMobile} {
    margin-left: auto;
    margin-top: ${Spacings.SPACING_2B};
  }
`;
const BlockContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: ${Spacings.SPACING_3B};
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_2B};
  }
`;

const BlockHeading = styled(Typography)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
    font-weight: ${Fonts.SEMIBOLD};
  }
`;
const BlockDetail = styled(Typography)`
  display: flex;
  margin-left: ${Spacings.SPACING_3B};
  color: var(--color-text-secondary);
  align-items: center;
  ${mediaQuery.uptoMobile} {
    display: block;
  }
`;

const BlockDetailContent = styled.div`
  display: flex;
`;

const ParentsCovered = ({ data }) => {
  const { isMobile } = useWindowSize();
  const { heading, subHeading, infoBlocks } = data;
  return (
    <GridContainer>
      <Container>
        {heading ? (
          <ColoredHeading variant="h4">
            <StyledHeading>{heading}</StyledHeading>
          </ColoredHeading>
        ) : (
          <StyledHeading variant="h4">
            <ColoredHeading>Parents,</ColoredHeading> we’ve got you covered
          </StyledHeading>
        )}
        <StyledSubHeading variant="p1">{subHeading}</StyledSubHeading>
        <InfoBlocks>
          {infoBlocks.map((block) => {
            const { blockHeading, blockDetails, blockImg, paymentModeIcon } =
              block;
            return (
              <Block>
                <BlockIcon
                  src={blockImg} // replace with blockImg
                  width={isMobile ? 40 : 56}
                  height={isMobile ? 40 : 56}
                  alt="blockImg"
                />
                <BlockContent>
                  <BlockHeading variant="h4">{blockHeading}</BlockHeading>
                  {blockDetails.map((detail, index) => {
                    const isLastIndex = blockDetails.length - 1 === index;
                    return (
                      <BlockDetailContent>
                        <CheckContained height={20} width={20} />
                        <BlockDetail variant="p2">
                          {' '}
                          {detail}
                          {isLastIndex && paymentModeIcon && (
                            <BlockDetailIcon
                              src={paymentModeIcon} // replace with paymentModeIcon
                              width={148}
                              height={16}
                              alt="image"
                            />
                          )}
                        </BlockDetail>
                      </BlockDetailContent>
                    );
                  })}
                </BlockContent>
              </Block>
            );
          })}
        </InfoBlocks>
      </Container>
    </GridContainer>
  );
};

export default ParentsCovered;
